export const LISTS_LOADER_DATA_TEST_ID = 'save-to-list-loader'
export const CREATE_LIST_BUTTON_DATA_TEST_ID = 'save-to-list-create-list-button'
export const SAVE_BUTTON_DATA_TEST_ID = 'save-to-list-save-button'
export const LIST_CHECKBOX = 'save-to-list-data-checkbox-'
export const LIST_NAME = 'save-to-list-data-name-'
export const LIST_ITEMS_COUNT = 'save-to-list-data-count-'
export const LIST_PRIVATE = 'save-to-list-data-private-'

export const ITEM_HEIGHT = 60
export const DEFAULT_LIST_HEIGHT = 300
export const DEFAULT_LIST_WIDTH = 650
